export const StatusBadge = ({ status, type = "email" }) => {
  const getStatusClass = () => {
    if (type === "email") {
      switch (status) {
        case "pending": return "status-pending";
        case "sent": return "status-sent";
        case "delivered": return "status-delivered";
        case "read": return "status-read";
        case "failed": return "status-failed";
        default: return "status-pending";
      }
    } else {
      switch (status) {
        case "not_created": return "status-not_created";
        case "created": return "status-created";
        case "added_to_wallet": return "status-added_to_wallet";
        default: return "status-not_created";
      }
    }
  };

  const getLabel = () => {
    if (type === "email") {
      switch (status) {
        case "pending": return "In attesa";
        case "sent": return "Inviata";
        case "delivered": return "Consegnata";
        case "read": return "Letta";
        case "failed": return "Fallita";
        default: return status;
      }
    } else {
      switch (status) {
        case "not_created": return "Non creata";
        case "created": return "Creata";
        case "added_to_wallet": return "Nel wallet";
        default: return status;
      }
    }
  };

  return (
    <span className={`status-badge ${getStatusClass()}`} data-testid={`status-badge-${type}`}>
      {getLabel()}
    </span>
  );
};
